"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  padding-left: 21px;\n  padding-right: 21.5px;\n\n  &:before {\n    animation: ", " 0.5s infinite linear;\n    border: 1px solid ", ";\n    margin-left: 13px;\n    margin-right: 13px;\n    border-left-color: ", ";\n    border-radius: 50%;\n    content: '';\n    height: 22px;\n    opacity: 0;\n    opacity: 1;\n    transform: translateX(0);\n    transition: opacity 0.3s ease, transform 0.1s 0.3s;\n    width: 22px;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(0);\n  }\n  to {\n    transform: rotate(359deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toasterLoading = void 0;

var _stylitas = require("@creditas/stylitas");

var rotation = (0, _stylitas.keyframes)(_templateObject());

var toasterLoading = function toasterLoading(_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return (0, _stylitas.css)(_templateObject2(), rotation, theme["bColor".concat(variant)], theme.bColorneutral01);
};

exports.toasterLoading = toasterLoading;